import { Brand } from '@/types';
import { OEMS } from '@/constants';

export interface RawOem {
  id: number;
  name: string;
}

export interface OemDisplayGroup {
  ids: number[];
  name: string;
}

const OEM_NAME_OVERRIDES: Record<string, string> = {
  psa: 'Stellantis',
  psa_fleet: 'Stellantis',
  daimler: 'Mercedes-Benz',
  volvo: 'Volvo Cars',
};

const toBrandSlug = (name: string) => name.trim().toLowerCase().replace(/\s+/g, '_');

export const getOemDisplayName = (rawName: string): string => {
  const slug = toBrandSlug(rawName);

  if (OEM_NAME_OVERRIDES[slug]) {
    return OEM_NAME_OVERRIDES[slug];
  }

  const matchedGroup = Object.values(OEMS).find((group) => group.brands.includes(slug as Brand));

  return matchedGroup ? matchedGroup.name : rawName;
};

export const groupOemsForDisplay = (oems: RawOem[]): OemDisplayGroup[] => {
  const groups = new Map<string, number[]>();

  for (const oem of oems) {
    const displayName = getOemDisplayName(oem.name);
    const ids = groups.get(displayName) ?? [];
    ids.push(oem.id);
    groups.set(displayName, ids);
  }

  return Array.from(groups.entries()).map(([name, ids]) => ({ name, ids }));
};
